module.exports = __webpack_public_path__ + "img/car.e284f953.jpg";